/**
 * @author EdenCha <eden@nurigo.net>
 */
import React from 'react'
import { setPropTypes, setDefaultProps } from 'lib/setPropTypes'
import withStyles from '@material-ui/core/styles/withStyles'
// import omitBy from 'lodash/omitBy'

// material UI
import Typography from '@material-ui/core/Typography'

// material ui icon
// import GetAppIcon from '@material-ui/icons/GetApp'

// my components
// import UserComponentName from 'components/molecules/UserComponentName'

// my containers
// import UserContainerName from 'containers/UserContainerName'

// libraries
// import config from 'config'
import { isString, isElement, isArray } from 'lib/detectType'

const styles = theme => ({
  root: {},
  popupContent: { height: '100%' }
})
export const useProps = {
  testVar: { default: '1234', type: 'string.isRequired' }
}
/**
 * (작성된 설명이 없습니다.)
 */
const PopupContent = React.memo(
  ({ classes, proxy, ...props }) => {
    const {
      popupKey,
      Context,
      children,
      popupContentWidth,
      popupContentHeight,
      childrenProps = {}
    } = props
    const addedProps = {
      ...childrenProps,
      popupKey,
      popupContentWidth,
      popupContentHeight
    }
    return (
      <div style={{ height: '100%' }}>
        {isString(Context) && (
          <Typography
            style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}
            className={classes.popupText}
            variant="body2"
          >
            {Context}
          </Typography>
        )}
        {isElement(Context) && React.cloneElement(Context, addedProps)}
        {isElement(children) && React.cloneElement(children, addedProps)}
        {isArray(Context) &&
          Context.map(ct => {
            return isElement(ct) && React.cloneElement(ct, addedProps)
          })}
        {isArray(children) &&
          children.map(child => {
            return isElement(child) && React.cloneElement(child, addedProps)
          })}
      </div>
    )
  },
  (prevProps, nextProps) => {
    return false
  }
)

PopupContent.defaultProps = setDefaultProps(useProps)
PopupContent.propTypes = setPropTypes(useProps)
export default withStyles(styles)(PopupContent)
